import { Gating } from "~/src/api";

export async function checkEntityAccess(
  ...args: Parameters<typeof Gating.checkEntityAccess>
): ReturnType<typeof Gating.checkEntityAccess> {
  const ids = args[0];
  const splits = ids.group(200);

  const res = await Promise.all(
    splits.map((split) => Gating.checkEntityAccess(split, args[1])),
  );

  let masterMap = {};

  res.forEach((resp) => {
    masterMap = {
      ...resp.attributes.map,
    };
  });

  return {
    ...res[0]!,
    attributes: {
      ...res[0]!.attributes,
      map: masterMap,
    },
  };
}
